var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"image-thumbnail",class:_vm.classes,attrs:{"src":_vm.item.thumbnail,"width":"160"},on:{"click":_vm.displayImage}})}
var staticRenderFns = []

export { render, staticRenderFns }